<template>
  <div>
    <div
      v-if="text"
      id="floatContainer"
      class="relative transition-colors w-96 my-4 border border-1 border-gray-400 hover:border-secondary hover:bg-primary focus-within:border-secondary bg-white rounded-lg"
    >
      <input
        class="block w-full appearance-none focus:outline-none bg-transparent placeholder-transparent pl-4"
        style="height: 50px;"
        :id="`input-${this.uuid}`"
        :value="value"
        @input="$emit('input', $event.target.value)"
        placeholder="a"
        type="text"
      />
      <label
        id="label"
        class="absolute left-3.5 top-4 z-1 duration-200 text-grey px-1 cursor-text"
        :for="`input-${this.uuid}`"
        >{{ label }}</label
      >
    </div>
    <div
      v-if="file"
      id="floatContainer"
      class="relative transition-colors w-96 my-4 border border-1 border-gray-400 hover:border-secondary hover:bg-primary focus-within:border-secondary bg-white rounded-lg py-4 px-3.5"
    >
      <input
        class="hidden focus:outline-none placeholder-transparent"
        :id="`input-${this.uuid}`"
        :value="value"
        @input="$emit('input', $event.target.value)"
        placeholder="a"
        type="file"
        :accept="accepting"
      />
      <label
        class="text-secondary"
        :for="`input-${this.uuid}`"
        style="cursor: pointer!important; background-color: transparent;"
      >
        <FontAwesomeIcon
          :icon="['fas', 'paperclip']"
          class="rounded-full font-black mr-2"
        />
        <span class="underline">
          {{ uploadedDocument }}
        </span>
      </label>
      <label
        id="label"
        class="absolute left-3.5 top-4 z-1 duration-200 text-grey px-1 cursor-text"
      >
        {{ label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Input",
  components: {},
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    text: {
      type: Boolean,
      default: false
    },
    file: {
      type: Boolean,
      default: false
    },
    accept: {
      type: Array,
      default: () => []
    },
    validationMessage: {
      type: String,
      default: ""
    }
  },
  computed: {
    inputField() {
      return [
        "py-4",
        "px-3.5",
        "bg-white",
        "rounded-lg",
        "focus:outline-none",
        "text-gray",
        "border",
        "border-solid",
        "border-secondary",
        "overflow-hidden"
        // "pointer-events-none"
      ];
    },
    accepting() {
      return this.accept
        .map(fileType => {
          return `.${fileType}, `;
        })
        .join("");
    },
    uploadedDocument() {
      if (!this.file) return;

      if (this.value) {
        return this.value.split("\\").slice(-1)[0];
      }

      return "Upload Documents";
    }
  },
  data() {
    return {
      uuid: null
    };
  },
  created() {
    this.uuid = this.$uuid.v4();
  },
  watch: {
    value: function(newValue) {
      if (this.file) {
        if (!newValue) return;
        const fileType = newValue.split(".").slice(-1)[0];

        if (this.accept.includes(fileType)) {
          this.$emit("validated");
        } else {
          alert(this.validationMessage);
          this.$emit("input", null);
        }
      }
    }
  }
};
</script>

<style scoped>
#floatContainer:hover > #label {
  @apply text-secondary;
  /* background: linear-gradient(
    180deg,
    transparent 47%,
    var(--color-primary) 47%
  ); */
}

input:focus-within ~ label {
  @apply transform scale-75 -translate-y-7 text-secondary font-bold cursor-default;
}

input:focus-within ~ label,
input:not(:placeholder-shown) ~ label {
  @apply transform scale-75 -translate-y-7 font-bold cursor-default bg-white;
}

input:focus-within ~ label {
  @apply text-secondary;
}
</style>
